<template>
    <v-progress-linear
        height="8"
        v-if="isLoading"
        indeterminate
        color="success"
    ></v-progress-linear>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
